import { Dialog } from '@mui/material';
import { styled as muiStyled } from '@mui/material/styles';

import { COLOR_THEME } from 'constants/colorThemes';
import ColormapInterface from 'shared-types/colormapinterface';
import { borderRadius, getSpacing, letterSpacing } from 'stylesheetB2b';

const MODAL_Z_INDEX = '10 !important';

export const StyledDialog = muiStyled(Dialog)<{
  width: string;
  colortheme: COLOR_THEME;
  colors: ColormapInterface;
}>(({ width, colors }) => ({
  // @ts-ignore: !important is necessary because otherwise modal has inline style
  // overriding the position absolute we define here
  // https://github.com/mui-org/material-ui/issues/16442
  '	.MuiDialog-root': { position: 'absolute !important', zIndex: MODAL_Z_INDEX },
  '.MuiDialog-paper': {
    width,
    borderRadius: borderRadius.XLarge,
    padding: `${getSpacing(9)} ${getSpacing(5)} ${getSpacing(6)}`,
    color: colors.defaultText,
    letterSpacing: letterSpacing.normal,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    backgroundColor: colors.modalBackground,
  },
}));
